var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfigContext, useTheme } from '@/hoc';
import { useState } from 'react';
import GenerateScriptCode, { generateScriptCodeString } from './GenerateViewScript';
export function CodePreview(_a) {
    var _b = _a.codeBlockClassName, codeBlockClassName = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? 'HTML' : _c;
    var _d = useState(false), copied = _d[0], setCopied = _d[1];
    var config = useConfigContext().config;
    var theme = useTheme().theme;
    var handleCopy = function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
                .writeText(generateScriptCodeString({
                framework: label,
                config: __assign(__assign({}, config), { shouldIncludeAdminModule: false }),
                theme: theme,
                componentName: 'Auth',
            }))
                .then(function () {
                setCopied(true);
                setTimeout(function () { return setCopied(false); }, 2000);
            });
        }
        else {
            console.error('Clipboard API not supported');
        }
    };
    return (_jsxs("div", { className: 'vas-w-full vas-relative', children: [_jsx("div", { className: 'vas-absolute vas-top-0 vas-right-0 vas-m-2', children: _jsx("button", { onClick: handleCopy, className: 'vas-rounded-md vas-text-primary vas-px-1 vas-py-1', children: copied ? (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', className: 'vas-h-6 vas-w-6', fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, d: 'M5 13l4 4L19 7' }) })) : (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', strokeWidth: 1.5, stroke: 'currentColor', className: 'vas-size-6', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75' }) })) }) }), _jsx("pre", { className: "vas-mb-4 vas-max-h-72 vas-overflow-auto vas-bg-gray-100 vas-p-4 ".concat(codeBlockClassName), children: _jsx(GenerateScriptCode, { framework: label, config: config, theme: theme, componentName: 'Auth' }) })] }));
}
